(() => {
  const request = async (root, url, options = {}) => {
    const response = await fetch(url, { headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, ...options });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || root.dataset.errorLabel);
    return data;
  };

  document.querySelectorAll('[data-quick-catalog]').forEach(root => {
    const panel = root.querySelector('[data-catalog-drafts]');
    if (!panel) return;
    const list = panel.querySelector('[data-catalog-drafts-list]');
    const refresh = panel.querySelector('[data-catalog-drafts-refresh]');
    const status = root.querySelector('[data-catalog-status]');
    const minimumOrderCents = 20000;
    const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
      style: 'currency',
      currency: root.dataset.currency || 'EUR'
    }).format((Number(cents) || 0) / 100);
    const showMinimumOrderNotice = cart => {
      const remaining = minimumOrderCents - (Number(cart.total_price) || 0);
      if (remaining <= 0) {
        status.textContent = root.dataset.minimumReachedLabel;
        status.style.cssText = 'margin-top:14px;padding:13px 16px;border:1px solid #7ac89a;border-radius:9px;background:#ebf8f0;color:#176d3a;font-weight:700;';
        return;
      }
      const message = root.dataset.minimumMessage
        .replace('{current}', formatMoney(cart.total_price))
        .replace('{minimum}', formatMoney(minimumOrderCents))
        .replace('{remaining}', formatMoney(remaining));
      status.textContent = message;
      status.style.cssText = 'margin-top:14px;padding:13px 16px;border:1px solid #f1ad42;border-radius:9px;background:#fff4df;color:#8a4b00;font-weight:700;';
      window.alert(message);
    };
    const load = async () => {
      list.textContent = panel.dataset.loadingLabel;
      try {
        const data = await request(root, root.dataset.draftsEndpoint);
        const drafts = data.drafts || [];
        list.replaceChildren();
        if (!drafts.length) {
          list.textContent = panel.dataset.emptyLabel;
          return;
        }
        drafts.forEach(draft => {
          const card = document.createElement('article');
          const info = document.createElement('div');
          const title = document.createElement('strong');
          const details = document.createElement('span');
          const actions = document.createElement('div');
          const edit = document.createElement('button');
          const restore = document.createElement('button');
          const remove = document.createElement('button');
          card.className = 'besmart-quick-catalog__draft';
          title.textContent = draft.title;
          details.textContent = (draft.lines || []).length + ' ' + panel.dataset.itemsLabel;
          edit.type = restore.type = remove.type = 'button';
          edit.className = 'btn';
          restore.className = 'btn button';
          remove.className = 'btn';
          edit.textContent = root.dataset.editDraftLabel;
          restore.textContent = panel.dataset.restoreLabel;
          remove.textContent = panel.dataset.deleteLabel;
          info.append(title, details);
          actions.append(edit, restore, remove);
          card.append(info, actions);
          edit.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent('besmart:edit-draft', { detail: { draft } }));
          });
          restore.addEventListener('click', async () => {
            restore.disabled = true;
            try {
              const added = await request(root, (window.Shopify?.routes?.root || '/') + 'cart/add.js', {
                method: 'POST',
                body: JSON.stringify({
                  items: draft.lines || [],
                  sections: ['minicart'],
                  sections_url: window.location.pathname
                })
              });
              const cart = await request(root, (window.Shopify?.routes?.root || '/') + 'cart.js');
              document.querySelectorAll('.js-cart-count, .header__counter, .cart-count').forEach(element => {
                element.textContent = String(cart.item_count || 0);
                element.dataset.jsCartCount = String(cart.item_count || 0);
              });
              document.body.dispatchEvent(new CustomEvent('drawer:Minicart', {
                detail: { response: added },
                bubbles: true
              }));
              showMinimumOrderNotice(cart);
              window.scrollTo({ top: 0, behavior: 'smooth' });
              restore.disabled = false;
            } catch (error) {
              status.textContent = error.message || root.dataset.errorLabel;
              restore.disabled = false;
            }
          });
          remove.addEventListener('click', async () => {
            if (!window.confirm(panel.dataset.deleteConfirm)) return;
            remove.disabled = true;
            try {
              await request(root, root.dataset.draftsEndpoint, { method: 'POST', body: JSON.stringify({ action: 'delete', id: draft.id }) });
              load();
            } catch (error) {
              status.textContent = error.message || root.dataset.errorLabel;
              remove.disabled = false;
            }
          });
          list.append(card);
        });
      } catch (error) {
        list.textContent = error.message || root.dataset.errorLabel;
      }
    };
    refresh.addEventListener('click', load);
    root.querySelector('[data-catalog-save]').addEventListener('click', () => window.setTimeout(load, 1500));
    window.addEventListener('besmart:drafts-changed', load);
    load();
  });
})();
